import React from "react";
import Grid from "../Grid/Grid";
import GridItem from "../GridItem/GridItem";
import "./FileDownload.css";
export const FileDownload = ({
  coreFileDatabaseId,
  mediaItemUrl,
  mediaItemContent,
}) => {
  return (
    <>
      {mediaItemContent
        .filter((media) => media.databaseId == coreFileDatabaseId)
        .map((filteredMedia, index) => (
          <a
            href={mediaItemUrl}
            download
            type={filteredMedia.mimeType}
            className="c-coop-download"
            aria-describedby={`caption-${filteredMedia.databaseId}`}
            key={index}
          >
            <Grid center key={index}>
              <GridItem
                size={9}
                sm={9}
                md={10}
                lg={10}
                key={`meta-item_${index}`}
              >
                <p className="c-coop-download__title">{filteredMedia.title}</p>
                <div id={`caption-${filteredMedia.databaseId}`}>
                  <p className="coop-t-font-size-16 c-coop-download__meta">
                    <span className="c-coop-download__meta-item">
                      {filteredMedia.localFile.extension}
                    </span>
                    <span className="c-coop-download__meta-item">
                      {filteredMedia.localFile.prettySize}
                    </span>
                  </p>
                  <p className="coop-t-font-size-16 c-coop-download__meta">
                    <time
                      dateTime={filteredMedia.date}
                      className="c-coop-download__meta-item c-coop-download__meta-item-date"
                    >
                      Uploaded {filteredMedia.dateGmt}
                    </time>
                  </p>
                </div>
              </GridItem>
              <GridItem
                className="c-coop-download__icon-container"
                size={3}
                sm={3}
                md={2}
                lg={2}
                key={`meta-icon_${index}`}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  className="c-coop-download__icon"
                  width="33"
                  height="32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Download {filteredMedia.title}</title>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.97 20.646a1 1 0 0 0-.74.29c-.192.194-.289.44-.289.742v5.774c0 .839-.209 1.462-.627 1.871-.418.409-.756.613-1.013.613H4.79c-.815 0-1.464-.22-1.946-.661-.483-.441-.724-1.049-.724-1.823v-5.774c0-.301-.096-.548-.29-.742a1 1 0 0 0-.74-.29 1 1 0 0 0-.739.29c-.193.194-.29.44-.29.742v5.774c0 1.355.44 2.452 1.32 3.29C2.26 31.581 3.396 32 4.79 32H29.3c.88 0 1.715-.419 2.509-1.258.793-.838 1.19-1.935 1.19-3.29v-5.774c0-.301-.096-.548-.29-.742a1 1 0 0 0-.74-.29Zm-16.146 2.773c.043.064.091.102.145.113.053.01.101.048.144.113.065.043.14.07.226.08.085.011.15.016.193.016.042 0 .107-.005.192-.016a.513.513 0 0 0 .226-.08c.043 0 .09-.022.144-.065a.707.707 0 0 0 .145-.161l9.778-9.806a.92.92 0 0 0 .322-.71.92.92 0 0 0-.322-.71.915.915 0 0 0-.707-.322.915.915 0 0 0-.708.322l-8.041 8.032V1.032c0-.3-.097-.548-.29-.742a1 1 0 0 0-.74-.29 1 1 0 0 0-.74.29c-.192.194-.289.441-.289.742v19.193L7.461 12.29a.915.915 0 0 0-.708-.322.915.915 0 0 0-.707.322.92.92 0 0 0-.322.71c0 .28.107.527.322.742l9.778 9.677Z"
                    fill="#fff"
                  />
                </svg>
              </GridItem>
            </Grid>
          </a>
        ))}
    </>
  );
};
